import ai from '../ai.json'


var contentWritingAiPageArray =  ai.contentWritingAi

const listElement = contentWritingAiPageArray.map((element) => 

          <a onClick={()=>{openWebIntent(element.url)}} className='text-decoration-none'>
            <div className='border border-primary m-3 p-3 bg-black text-white rounded opacity-75'>
              <b>
                <center>
                {element.name}
                </center>
                
              </b>      
            </div>
          </a>
);





export default function ContentWritingAi() {
    return(
        <>
        <div>
                  {listElement}
        </div>
        </>
    )
}


function openWebIntent(url){
  if(url != null){
    window.Android.openWebIntent(url);
  }
}